import { render, staticRenderFns } from "./RuleFormula.vue?vue&type=template&id=2324f226"
import script from "./RuleFormula.vue?vue&type=script&lang=js"
export * from "./RuleFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports